import { ActionIcon, Tooltip, useMantineTheme } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import TagManager from 'react-gtm-module';
import { Copy, type Icon } from 'react-feather';

interface Props {
  name: string;
  data: string;
  IconComponent?: Icon;
  IconSize?: number;
  tooltipTimeoutInMs?: number;
  position?: string;
  googleEvent?: string;
}
export const CopyButton = ({
  name,
  data,
  IconComponent = Copy,
  tooltipTimeoutInMs = 1000,
  ...props
}: Props) => {
  const theme = useMantineTheme();
  const clipboard = useClipboard({ timeout: tooltipTimeoutInMs });

  const onCopy = () => {
    clipboard.copy(data);
    if (props.googleEvent) {
      TagManager.dataLayer({ dataLayer: { event: props.googleEvent } });
    }
  };

  return (
    <Tooltip
      label={`${name} copied to clipboard`}
      opened={clipboard.copied}
      withArrow
      data-testid={clipboard.copied ? 'copy-success-tooltip' : undefined}
      styles={{
        tooltip: {
          background: theme.other.overlay.background,
          color: theme.other.overlay.foreground,
          padding: theme.other.spacing.xs,
          borderRadius: theme.radius.md,
        },
      }}
    >
      <ActionIcon onClick={onCopy} size={32}>
        <IconComponent size={16} />
      </ActionIcon>
    </Tooltip>
  );
};
